﻿'use strict'

import dummy from '../../common/app/appPlugins';
import $ from 'jquery';
import * as Bootstrap from 'bootstrap';
import AppRouter from './router';
import App from './app';


$(document).ready(function () {
    var app = window.app = new App();
    app.router = new AppRouter({ app: app });
    app.start({});
});

function refreshToken() {
    //return userManager.signinSilent();
}
